import { useMutation } from '@lib/query/client';

interface SendVerificationCodeParams {
  email: string;
  redirectedFrom?: string | null;
  shellOnly?: boolean;
  includeMagicLink?: boolean;
}

interface SendVerificationCodeResponse {
  success: boolean;
  error?: string;
  /** Set for shell-claim sends. False means no code was emailed. */
  codeSent?: boolean;
}

async function sendVerificationCode(
  params: SendVerificationCodeParams
): Promise<SendVerificationCodeResponse> {
  const response = await fetch('/api/auth/verification/email/send-code', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: params.email,
      ...(params.redirectedFrom != null && params.redirectedFrom !== ''
        ? { redirectedFrom: params.redirectedFrom }
        : {}),
      ...(params.shellOnly ? { shellOnly: true } : {}),
      ...(params.includeMagicLink ? { includeMagicLink: true } : {}),
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to send verification code');
  }

  return data;
}

export function useSendVerificationCode() {
  return useMutation({
    mutationFn: sendVerificationCode,
  });
}
